import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaCity, FaArrowLeft } from "react-icons/fa";
import { getStaffDetails } from "../../redux/services/Staff Services/Staff.Services";
import { Link } from "react-router-dom";
const permissionsList = [
  // {
  //   label: "Employees",
  //   key: "employees",
  //   children: [
  //     { label: "Employee", key: "staff" },
  //     { label: "Roles", key: "role" },
  //     { label: "Departments", key: "department" },
  //     { label: "Activity", key: "StaffActivity" },
  //   ],
  // },
  {
    label: "Leads",
    key: "lead",
    children: [
      { label: "New", key: "newlead" },
      { label: "Pending", key: "pendinglead" },
      { label: "Others", key: "alllead" },
      { label: "Assigned Lead", key: "LeadAssigned" },
    ],
  },
  {
    label: "Dashboard",
    key: "dashboard",
  },
  // {
  //   label: "Inventory Management",
  //   key: "inventoryManagement",
  // },
  // {
  //   label: "Task",
  //   key: "task",
  // },
  // {
  //   label: "Chat",
  //   key: "chat",
  // },
  // {
  //   label: "Reminder",
  //   key: "reminder",
  // },
  // {
  //   label: "Meeting",
  //   key: "meeting",
  // },
  // {
  //   label: "Leave",
  //   key: "leave",
  // },
  // {
  //   label: "Calendar",
  //   key: "calendar",
  // },
  // {
  //   label: "Content / Setting",
  //   key: "settings",
  // },
];

function ViewStaff() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [staff, setStaff] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const formatDateTime = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).replace(/\//g, "-").replace(",", "");
  };

  const fetchStaffDetails = async () => {
    try {
      setLoading(true);
      const res = await getStaffDetails(id);
      if (res?.data?.success) {
        const data = res.data.data?.[0] || res.data.data;
        setStaff({
          ...data,
          detail: data?.staff_detail || {},
          permissions: data?.staff_permission || {},
        });
        setImageUrl(res.data.image_url || "");
      } else {
        const data = res?.data;
        if (data) {
          setStaff({
            ...data,
            detail: data?.staff_detail || {},
            permissions: data?.staff_permission || {},
          });
          setImageUrl(data.image_url || "");
        }
      }
    } catch (error) {
      console.log("Error:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      fetchStaffDetails();
    }
  }, [id]);
  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <h5 className="mt-3">Loading Staff Details...</h5>
      </div>
    );
  }
  if (!staff) {
    return (
      <div className="text-center py-5">
        <h5>No Staff Found</h5>
        <button className="btn btn-primary mt-3" onClick={() => navigate(-1)}>
          Go Back
        </button>
      </div>
    );
  }
  const isActive = staff?.status === "active" || staff?.status === 1;
  const detail = staff?.detail || {};
  const permissions = staff?.permissions || {};
  return (
    <>
      <div className="d-flex align-items-center justify-content-between  page-header-breadcrumb">
        <div className="title_member">
          <h4>Staff Details</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Staff  Details</span>
          </nav>
        </div>
        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <button
            className="add-btn"
            onClick={() => navigate(-1)}
          >
            Back
          </button>
        </div>
      </div>

      <div className="main_page">
        <div className="grid_design">
          {/* IMAGE */}
          <div className="grid_box">
            {detail?.image ? (
              <img
                src={`${imageUrl}${detail.image}`}
                alt={staff?.name}
                style={{
                  width: "150px",
                  height: "150px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "3px solid #ddd",
                }}
              />
            ) : (
              <div className="d-flex justify-content-center flex-wrap gap-2">
                <div
                  className="d-flex align-items-center justify-content-center bg-light"
                  style={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "50%",
                    border: "3px solid #ddd",
                    margin: "0 auto"
                  }}
                >
                  <FaCity size={50} color="#6c757d" />
                </div>
                <span
                  className={`status-badge ${isActive === "Active" ? "active" : "inactive"
                    }`}
                >
                  <span className="status-dot"></span>
                  {isActive ? "Active" : "Inactive"}
                </span>
                {/* <span className={`status-badge ${isActive ? "bg-success" : "bg-danger"}`}>
                  {isActive ? "Active" : "Inactive"}
                </span> */}
              </div>
            )}
          </div>
          <div className="grid_box_sec">
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="fw-bold text-muted">Name</label>
                  <input type="text" disabled className="form-control" value={staff?.name || "-"} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="fw-bold text-muted">Email</label>
                  <input type="text" disabled className="form-control" value={staff?.email || "-"} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="fw-bold text-muted">Password</label>
                  <input type="text" disabled className="form-control" value={staff?.simple_pass || "-"} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="fw-bold text-muted">Mobile</label>
                  <input type="text" disabled className="form-control" value={detail?.mobile || "-"} />
                </div>
              </div>
                      <div className="col-md-6">
                <div className="mb-3">
                  <label className="fw-bold text-muted">Department</label>
                  <input type="text" disabled className="form-control" value={detail?.department || "-"} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="fw-bold text-muted">Role</label>
                  <input type="text" disabled className="form-control" value={staff?.role || "-"} />
                </div>
              </div>
{/*       
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="fw-bold text-muted">Salary</label>
                  <input
                    type="text"
                    disabled
                    className="form-control"
                    value={`₹ ${detail?.salary || "-"}`}
                  />                </div>
              </div> */}
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="fw-bold text-muted">Joining Date</label>
                  <input type="text" disabled className="form-control" value={detail?.joining_date || "-"} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="fw-bold text-muted">Created At</label>
                  <input type="text" disabled className="form-control" value={staff?.created_at ? formatDateTime(staff.created_at) : "-"} />

                </div>
              </div>
              {/* <div className="col-md-6">
                <div className="mb-3">
                  <label className="fw-bold text-muted">Updated At</label>
                  <input type="text" disabled className="form-control" value={staff?.updated_at ? formatDateTime(staff.updated_at) : "-"} />

                </div>
              </div> */}
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="fw-bold text-muted">Address</label>
                  <input type="text" disabled className="form-control" value={detail?.address || "-"} />

                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card_box_new">
          <h4 className="">Permissions</h4>
           <div className="padding_15">
            <div className="row">
              {permissionsList.map((item) => (
                <div key={item.key} className="col-md-4 mb-4">
                  <div className="card_custum_viewstaff">
                    <div className="card-header all_padding_new d-flex align-items-center">
                      <input
                        className="form-check-input me-2"
                        type="checkbox"
                        id={`perm-${item.key}`}
                        checked={permissions[item.key] === 1}
                        disabled
                      />
                      <label
                        className="fw-bold mb-0"
                        htmlFor={`perm-${item.key}`}
                      >
                        {item.label}
                      </label>
                    </div>
                    {item.children?.length > 0 && (
                      <div className="card_custum_body">
                        {item.children.map((child) => (
                          <div key={child.key} className="d-flex align-items-center mb-2">
                            <input
                              className="form-check-input me-2"
                              type="checkbox"
                              id={`perm-${child.key}`}
                              checked={permissions[child.key] === 1}
                              disabled
                            />
                            <label
                              className="text-light mb-0"
                              htmlFor={`perm-${child.key}`}
                            >
                              {child.label}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
        </div>
        </div>
        {/* PERMISSIONS SECTION */}
       
      </div>
    </>
  );
}

export default ViewStaff;